var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-table-card",
    { staticClass: "card" },
    [
      _c("stitch-loader", { attrs: { loading: _vm.loading, size: 45 } }),
      _vm.hasUsersToDisplay
        ? _c(
            "div",
            [
              _c("div", { staticClass: "titleLine styleRow" }, [
                _c("p", { staticClass: "rowElements" }),
                _c("p", { staticClass: "rowElements" }, [_vm._v("Name")]),
                _c("p", { staticClass: "rowElements" }, [_vm._v("Email")]),
                _c("p", { staticClass: "rowElements" }, [_vm._v("Roles")]),
                _c("p", { staticClass: "rowElements" })
              ]),
              _vm._l(_vm.users, function(user) {
                return _c(
                  "div",
                  { key: user.user_id, staticClass: "styleRow colorHover" },
                  [
                    _c(
                      "div",
                      { staticClass: "rowElements" },
                      [
                        _c("md-avatar", { staticClass: "md-medium" }, [
                          _c("img", { attrs: { src: user.picture } })
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticClass: "rowElements" }, [
                      _vm._v(_vm._s(user.user_metadata.name))
                    ]),
                    _c("div", { staticClass: "rowElements overflow" }, [
                      _vm._v(_vm._s(user.email))
                    ]),
                    _c("div", { staticClass: "rowElements overflow" }, [
                      _vm._v(_vm._s(_vm.fixForRoles(user)))
                    ]),
                    _c(
                      "div",
                      { staticClass: "rowElements iconsContainer overflow" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button md-raised btn",
                            on: {
                              click: function($event) {
                                return _vm.editUser(user.user_id)
                              }
                            }
                          },
                          [
                            _c("md-icon", {
                              staticClass: "icon",
                              attrs: { "md-iconset": "fa fa-pencil-alt" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "md-button",
                          {
                            staticClass: "md-icon-button md-raised btn",
                            attrs: {
                              disabled:
                                ((_vm.isAdmin() || _vm.isAccountAdmin()) &&
                                  user.app_metadata.authorization.roles.includes(
                                    "Admin"
                                  )) ||
                                user.user_id === _vm.siteuser.user_id
                            },
                            on: {
                              click: function($event) {
                                _vm.deleteUser(
                                  user.name,
                                  user.nickname,
                                  user.user_id,
                                  _vm.fixForRoles(user)
                                )
                              }
                            }
                          },
                          [
                            _c("md-icon", {
                              staticClass: "icon",
                              attrs: { "md-iconset": "fa fa-trash-alt" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              }),
              _c("md-table-pagination", {
                attrs: {
                  "md-size": _vm.currentPagination.size,
                  "md-page": _vm.currentPagination.page,
                  "md-total": _vm.totalUsers,
                  "md-label": "Users",
                  "md-separator": "of",
                  "md-page-options": [10, 50]
                },
                on: { pagination: _vm.onPageChanged }
              })
            ],
            2
          )
        : _vm._e(),
      _vm.hasNoResults
        ? _c(
            "md-layout",
            { attrs: { id: "no-results", "md-align": "center" } },
            [
              _c("md-icon", {
                staticClass: "md-accent",
                attrs: { "md-iconset": "fa fa-exclamation-circle" }
              }),
              _vm._v("No items to show")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a8927e9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8927e9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/user/UserTable.vue
// module id = 724
// module chunks = 0